import type {
  REQUEST_LOGS_DATE_RANGE_VALUES,
  REQUEST_LOGS_STATUS_VALUES,
} from './analytics'

export const ACTION_LOGS_LABELS = {
  STATUS: {
    all: 'All',
    success: 'Success',
    failed: 'Failed',
  } as Record<REQUEST_LOGS_STATUS_VALUES, string>,
  DATE_RANGE: {
    '1d': '1 day',
    '1w': '1 week',
    '1m': '1 month',
    '3m': '3 months',
  } as Record<REQUEST_LOGS_DATE_RANGE_VALUES, string>,
}
